import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
//import Loader from "../Loader/Loader";
import BlogDetailContent from "./BlogDetailContent";
import {actionToGetBlogDataApiCall} from "../../../redux/action";

const BlogContent = () => {
    const dispatch = useDispatch();
    const [isLoading,setIsLoading] = useState(true);
    const {slug,cat_slug, sub_cat_slug, product_slug} = useParams();

    const blogListData = useSelector((state) => state.webSetting.blogListData);


    useEffect(() => {
        setIsLoading(true);
        if (slug) {
            dispatch(actionToGetBlogDataApiCall({slug})).then(res=>{setIsLoading(false);});
        }
        }, [dispatch, slug,cat_slug, sub_cat_slug, product_slug]);


    /*if(isLoading){
        return <Loader />;
    }*/
    return (
        <div className='p-10'>
            {Object.values(blogListData).map((data, index) => (
                <BlogDetailContent key={index} contentData={data} />
            ))}
        </div>
    );
};

export default BlogContent;
